module.exports = __webpack_public_path__ + "static/media/neuter.e409af2b.svg";